// Content for the public policy pages (Privacy, Terms, Refund, Return, Delivery).
// Each section's `body` is a list of paragraphs; a paragraph that is an array
// renders as a bulleted list.

export const COMPANY = {
  legalName: "ALPAAGO INDIA PVT LTD",
  brand: "PickaaGo",
  email: "contact@pickaago.com",
  phone: "+91 73974 60454",
};

export const LAST_UPDATED = "4 October 2026";

const contactParagraph = `For any questions, contact us at ${COMPANY.email} or ${COMPANY.phone}.`;

export const policies = {
  privacy: {
    title: "Privacy Policy",
    intro: `${COMPANY.brand}, operated by ${COMPANY.legalName}, respects your privacy. This policy explains in general terms how we handle your information when you use our website, app and services.`,
    sections: [
      {
        heading: "Information we collect",
        body: [
          "We collect the information you provide, such as your name and contact details, and information generated when you use our services, such as delivery and activity records.",
        ],
      },
      {
        heading: "How we use it",
        body: [
          "We use your information to provide, operate and improve our services, and to communicate with you about them.",
        ],
      },
      {
        heading: "Sharing",
        body: [
          "We do not sell your personal information. We may share it with trusted service providers who help us run our services, or where required by law.",
        ],
      },
      {
        heading: "Your choices",
        body: [
          "You may contact us to access, update or delete your information.",
        ],
      },
      {
        heading: "Changes and contact",
        body: [
          "We may update this policy from time to time. The latest version will always be available on this page.",
          contactParagraph,
        ],
      },
    ],
  },

  terms: {
    title: "Terms & Conditions",
    intro: `By using the ${COMPANY.brand} website, app or services, you agree to these terms.`,
    sections: [
      {
        heading: "Use of services",
        body: [
          "Please use our services lawfully and responsibly. Keep your account details and PINs confidential.",
        ],
      },
      {
        heading: "Our services",
        body: [
          "We work to keep our services available and reliable, but they are provided on an \"as is\" and \"as available\" basis. Features may change over time.",
        ],
      },
      {
        heading: "Intellectual property",
        body: [
          `All content, branding and software of ${COMPANY.brand} belong to ${COMPANY.legalName}.`,
        ],
      },
      {
        heading: "Changes and contact",
        body: [
          "We may update these terms from time to time. Continued use of our services means you accept the updated terms.",
          contactParagraph,
        ],
      },
    ],
  },

  refund: {
    title: "Refund Policy",
    intro: "Refund requests are reviewed on a case-by-case basis.",
    sections: [
      {
        heading: "Requesting a refund",
        body: [
          "To request a refund, contact us with your order details and the reason for your request. Our team will review it and get back to you.",
          "Approved refunds are processed to the original payment method.",
          contactParagraph,
        ],
      },
    ],
  },

  return: {
    title: "Return Policy",
    intro: "Return requests are reviewed on a case-by-case basis.",
    sections: [
      {
        heading: "Requesting a return",
        body: [
          "If there is a problem with a product you received, contact us with your order details. Our team will review your request and guide you through the next steps.",
          "Products should be returned in their original condition, with all accessories and packaging where possible.",
          contactParagraph,
        ],
      },
    ],
  },

  delivery: {
    title: "Delivery Policy",
    intro: `${COMPANY.brand} products are delivered to serviceable locations.`,
    sections: [
      {
        heading: "Delivery",
        body: [
          "Delivery timelines may vary depending on your location and availability. We will keep you informed about the status of your order.",
          "If you face any issue with your delivery, please contact us.",
          contactParagraph,
        ],
      },
    ],
  },
};
